var map = {
	"./1.svg": 1092,
	"./10.svg": 1093,
	"./11.svg": 1094,
	"./12.svg": 1095,
	"./13.svg": 1096,
	"./14.svg": 1097,
	"./15.svg": 1098,
	"./16.svg": 1099,
	"./17.svg": 1100,
	"./18.svg": 1101,
	"./19.svg": 1102,
	"./2.svg": 1103,
	"./20.svg": 1104,
	"./21.svg": 1105,
	"./22.svg": 1106,
	"./23.svg": 1107,
	"./24.svg": 1108,
	"./25.svg": 1109,
	"./26.svg": 1110,
	"./27.svg": 1111,
	"./3.svg": 1112,
	"./4.svg": 1113,
	"./5.svg": 1114,
	"./6.svg": 1115,
	"./7.svg": 1116,
	"./8.svg": 1117,
	"./9.svg": 1118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1091;